import * as jQuery from 'jquery';

import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import * as _ from 'underscore';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { CreativesCoxV5Component } from '../creatives-cox-v5/creatives-cox-v5.component';

@Component({
	selector: 'app-creative-carousel-r5',
	styleUrls: ['../creatives-cox-v5/creatives-cox-v5.component.css'],
	templateUrl: '../creatives-cox-v5/creatives-cox-v5.component.html'
})
export class CreativeCarouselR5Component extends CreativesCoxV5Component implements OnInit {
	@Input() sectionclass: any;
	@Input() sectiontitle: string;
	@Input() producttype: string;
	public socialCreative: boolean = false;
	public isR9: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.selectedIndex = 0;
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.options = {
			autoRotationLocked: true,
			autoRotationSpeed: 6000000,
			border: 0,
			clicking: true,
			dir: 'rtl',
			height: 400,
			loop: true,
			perspective: 1,
			sourceProp: '',
			space: 300,
			startSlide: 0,
			visible: 7,
			width: 360
		};
		this.badgeClass = 'badge-display';
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
		super.ngOnInit();
	}

	openModal(id: string, creative: any): void {
		if (!this.selectedCreative) {
			this.selectedCreative = creative;
		}
		setTimeout(() => {
			this.modalService.open(id);
		}, 200);
	}

	closeModal(id: string): void {
		this.selectedCreative = undefined;
		this.modalService.close(id);
	}

	isActiveSlide(index: number): boolean {
		return this.selectedIndex === index;
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = true;
		this.socialCreative = this.sectiontitle.indexOf('Social') !== -1;
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.responseData = response.data;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});

		const dateSet = {
			depricatedDate: this.analyticsDataModel.depricatedDate,
			endDate: this.analyticsDataModel.endDate,
			goLiveDate: this.analyticsDataModel.goLiveDate,
			startDate: this.analyticsDataModel.startDate
		};
		this.templegend = this.checkForVisibility(this.legend, dateSet);
	}

	ngAfterViewInit(): void {
		this.cdr.detectChanges();
	}
	ngAfterViewChecked(): void {
		this.cdr.detectChanges();
		jQuery('.carouselSlide.current').click();
	}
	ngAfterContentChecked(): void {
		const changeCarouselHeight = _.find(this.legend, (legend: any): boolean => {
			return legend['displayName'] === 'Engagments';
		});
		jQuery('.inline' + this.displayStats.length).css('width', 100 / this.displayStats.length + '%');

		jQuery('.carouselSlide').css({
			height: 'unset',
			width: 'unset'
		});
		jQuery('.carouselSlideActive').css({
			height: 'unset',
			width: 'unset'
		});
		jQuery('.display-creative-card').css({
			cursor: 'pointer'
		});
		jQuery('.carousel-3d').css({
			height: '300px',
			width: '30%'
		});
		jQuery('.social_creatives').css({
			'margin-top': '1%'
		});
		jQuery('.displayCreatives').css({
			'margin-top': '6%'
		});
		jQuery('.slide-3d').css({
			'border-color': 'rgba(0, 0, 0, 0.5)',
			'border-style': 'none',
			'border-width': '1px'
		});
		if (window.matchMedia('(min-width: 1800px)').matches) {
			jQuery('.social_creatives .carousel-3d-container').css({
				'margin-left': '3%'
			});
		} else {
			jQuery('.social_creatives .carousel-3d-container').css({
				'margin-left': '0%'
			});
		}
		if (window.matchMedia('(min-width: 2600px)').matches) {
			jQuery('.social_creatives .carouselSlideActive').css({
				left: '15px'
			});
		} else {
			jQuery('.social_creatives .carouselSlideActive').css({
				left: '0px'
			});
		}
		if (this.isR11) {
			jQuery('.badge-display p').css({ 'background-color': this.colorPalette.primaryColor });
			if (this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL) {
				if (this.socialCreative) {
					jQuery('.display_creative_img').css({
						height: '290px'
					});
					jQuery('.creative-performance-stats').css({
						height: '550px'
					});
				}
			} else {
				jQuery('.creative-performance-stats').css({
					height: '450px'
				});
			}
		} else if (changeCarouselHeight) {
			jQuery('.creative-performance-stats').css({
				height: '520px'
			});
		}
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
		this.selectedCreative = undefined;
	}
}
